module.exports = __webpack_public_path__ + "assets/img/vakifbank@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-logo/vakifbank@2x.png
// module id = 143
// module chunks = 0